<template>
  <div id="sticky-settings">

    <div v-if=showCloseButton v-show=!sideBarOpen @click="toggleSidebar()" class="toggle-filter-btn">
      <div class="toggle-button">
        <i class="fal fa-cog portlet-icon toggle-icon"></i>
      </div>
    </div>

    <div class="slide-over-panel-right" id=slide-over-panel-right v-show="sideBarOpen">
      <div class="container">
        <div class="header" >
          <slot name="sidebar-header">
          </slot>
          <div v-if=showCloseButton @click="toggleSidebar()" class="toggle-filter-btn-close mt-3 ml-2  ">
            <i class="fas fa-times" style="cursor: pointer"></i>

          </div>

        </div>
        <div class="title mt-3">
          <slot name="sidebar-title">
          </slot>
        </div>
        <div class="body">
          <slot name="sidebar-body">
          </slot>
        </div>
        <div class="footer">
          <div class=" ">
            <slot name="sidebar-footer"></slot>
          </div>
        </div>
      </div>

      <div v-if="showOverflowBlock" class="overflow-block"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SideBarRight",
  props: {
    openOnCreate: {
      default: false
    },
    showCloseButton: {
      default: true
    },
    showOverflowBlock:{
      default:false
    },
    footer: {
      default: true,

    }
  },
  data() {
    return {

      sideBarOpen: false,
    }
  },
  methods: {
    closeOnClickOutside(e) {
      if (!document.getElementById('sticky-settings').contains(e.target) && this.sideBarOpen) {
        this.toggleSidebar()
      }
    },
    toggleSidebar() {
      this.sideBarOpen = !this.sideBarOpen;
      // $(".slide-over-panel-right").animate({width: 'toggle'},100);
    }
  },
  beforeDestroy() {
    // $(".slide-over-panel-right").animate({width: 'toggle'},0);
    // removeEventListener('click', this.closeOnClickOutside)
  },
  watch: {
    sideBarOpen(newV, oldV) {
      console.log('sidebar is : open ' + JSON.stringify(newV, oldV))
      if (newV) {
        // document.addEventListener('click', this.closeOnClickOutside)
      } else {
        // removeEventListener('click', this.closeOnClickOutside)

      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.sideBarOpen = this.openOnCreate
    })


  },

}

</script>

<style lang="scss" scoped>
$panelWidth: 400px;

#sticky-settings {
  font-family: "Open Sans", sans-serif;
  h3 {
    color: #000000;
    display: flex;
    flex-direction: column;

    padding: 0px;
    gap: 4px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
  }

  p {
    font-family: "Open Sans", sans-serif;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    /* identical to box height, or 20px */

    letter-spacing: 0.25px;

    /* Neutral Color / 700 */
    color:#000000;

    //color: #6A7178;
    display: flex;
    flex-direction: column;
    align-items: center;


    order: 1;
    flex-grow: 0;
  }
}

#slide-over-panel-right {
  width: $panelWidth;
  position: fixed;
  right: -25px;
  top: 60px;
  z-index: 1000;
  height: 100vh;
  -webkit-box-shadow: -17px 1px 21px -8px rgba(0, 0, 0, 0.59);
  box-shadow: -17px 1px 21px -8px rgba(0, 0, 0, 0.59);
  background: white;
  padding-right: 10px;

}
#slide-over-panel-right > .container {
  height: 100%;

}


.toggle-filter-btn {
  z-index: 999;
  cursor: pointer;
  font-size: 3rem;
  color: #00c9ff;
  position: fixed;
  right: 0;
  top: calc(20% - 3rem);
  background-color: #fcfcfc;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  -webkit-border-top-left-radius: 10px;
  -webkit-border-bottom-left-radius: 10px;
  -moz-border-radius-topleft: 10px;
  -moz-border-radius-bottomleft: 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  /*border: 1px solid #00c9ff;*/
  width: 6rem;
  height: 6rem;
  border-right: 0px;
  display: grid;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-items: center;
  -webkit-animation: slide-in-right 0.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 100ms both;
  animation: slide-in-right 0.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 100ms both;
}

.toggle-filter-btn-close {
  //position: relative;
  //top: 5px;
  //right: 5px;

  i {
    z-index: 999;
    cursor: pointer;
    font-size: 2.5rem;
    font-weight: 300;
    color: #000000;

    //right: -15px;
    //top: calc(50% - 3rem);
    //background-color: #ffffff;
    //border: 1px solid #00c9ff;
    //width: 4rem;
    //height: 4rem;
    display: grid;
    -webkit-box-align: center;
    -ms-flex-align: center;
    //align-items: center;
    //justify-items: center;
    -webkit-animation: swirl-in-fwd 0.2s ease-out 200ms both;
    animation: swirl-in-fwd 0.2s ease-out 200ms both;
    //border-radius: 100px;
  }
}


.container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows:0.05fr 0.1fr 1.5fr;
  gap: 7px 0px;
  grid-template-areas:
    "header"
    "title"
    "body"
    "footer";
}

.header {
  grid-area: header;
}

.body {
  grid-area: body;
  //z-index:2;
  //mask-image: linear-gradient(to bottom, black 100%, transparent 51%);
  //-webkit-mask-image: linear-gradient(to bottom, black 54%, black 32%, transparent 100%);


  //background: rgb(0,0,0);
  //background: -moz-linear-gradient(0deg, rgba(0,0,0,0.2) 0%, rgba(6,6,6,0.15) 9%, rgba(255,255,255,0.5) 20%);
  //background: -webkit-linear-gradient(0deg, rgba(0,0,0,0.2) 0%, rgba(6,6,6,0.15) 9%, rgba(255,255,255,0.5) 20%);
  //background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(6, 6, 6, 0.15) 9%, rgba(255, 255, 255, 0.5) 20%);
  //filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#ffffff",GradientType=1);

  overflow-y: auto;
}

.footer {
  z-index:2;
  grid-area: footer;
  width: 90%;
  position: absolute;
  bottom: 65px;
  padding: 5px 0;


}
.overflow-block{
  z-index:1;
  width: $panelWidth;
  height: 90px;
  position: absolute;
  bottom: 60px;
  background: linear-gradient(181.77deg, rgba(0, 0, 0, 0) 10.12%, rgba(0, 0, 0, 0.2) 47.86%);
}
.title {
  grid-area: title;
}

.body::-webkit-scrollbar {
  display: none;
  //width: 5px;
  //background-color: #F5F5F5;
}

//
///* Track */
//.body::-webkit-scrollbar-track {
//  box-shadow: inset 0 0 1px grey;
//  border-radius: 5px;
//}
//
///* Handle */
//.body::-webkit-scrollbar-thumb {
//  border-radius: 10px;
//  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
//  background-color: #2A52BE;
//}
//
///* Handle on hover */
//.body::-webkit-scrollbar-thumb:hover {
//  border-radius: 10px;
//  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
//  background-color: #4285F4;
//}


//.sidebar-footer {
//  position: relative;
//  width: 100vw;
//  left: calc(-50vw + 50%);
//}
/* ----------------------------------------------
 * Generated by Animista on 2022-3-15 15:31:12
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-in-right
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
</style>